// extracted by mini-css-extract-plugin
export default {"body":"style_body__EROfP","contact_form":"style_contact_form__YT2Lv","email":"style_email__oaCb8","password":"style_password__PinZj","success":"style_success__qaZbG"};